import {
  EDescriptionQualityReason,
  getActionableDescriptionQualityReasons,
} from 'partner360/entities/keyInitiatives'

const LOW_DESCRIPTION_SCORE_THRESHOLD = 62

export const isLowDescriptionQuality = (
  score: number | null,
  reasons: EDescriptionQualityReason[]
): boolean =>
  score === null ||
  score < LOW_DESCRIPTION_SCORE_THRESHOLD ||
  getActionableDescriptionQualityReasons(reasons).length > 1
